import {Observable} from 'rxjs';

export interface Link {
    name: string;
    id: number;
    link: string;
}

export abstract class LinksData {

    abstract list(search: string, pageNumber: number, pageSize: number, orderBy: string): Observable<any>;

    abstract get(id: number, cloudId: number): Observable<Link>;

    abstract update(user: Link): Observable<Link>;

    abstract create(user: Link): Observable<Link>;

    abstract delete(user: Link): Observable<Link>;

}
